<template>
  <!--  <el-aside width="200px" style="height: 100%">-->
  <!--    &lt;!&ndash; 侧边栏菜单区 &ndash;&gt;-->
  <!--    <el-menu background-color="#333744" text-color="#fff" active-text-color="#ffd04b">-->
  <!--      &lt;!&ndash; 一级菜单 &ndash;&gt;-->
  <!--      <el-submenu index="1">-->
  <!--        &lt;!&ndash; 一级菜单的模板区域 &ndash;&gt;-->
  <!--        <template slot="title">-->
  <!--          &lt;!&ndash; 图标 &ndash;&gt;-->
  <!--          <i class="el-icon-location"></i>-->
  <!--          &lt;!&ndash; 文本 &ndash;&gt;-->
  <!--          <span>导航一</span>-->
  <!--        </template>-->
  <!--        &lt;!&ndash; 二级菜单 &ndash;&gt;-->
  <!--        <el-menu-item index="1-4-1">-->
  <!--          <template slot="title">-->
  <!--            &lt;!&ndash; 图标 &ndash;&gt;-->
  <!--            <i class="el-icon-location"></i>-->
  <!--            &lt;!&ndash; 文本 &ndash;&gt;-->
  <!--            <span>二级菜单</span>-->
  <!--          </template>-->
  <!--        </el-menu-item>-->
  <!--      </el-submenu>-->
  <!--    </el-menu>-->
  <!--  </el-aside>-->
  <div class="el-tabs__nav-scroll">

    <!--        default-active="/home"-->
    <el-menu
        active-text-color="#ffd04b"
        background-color="#545c64"
        class="el-menu-vertical-demo"
        default-active="2"
        text-color="#fff"
        @open="handleOpen"
        @close="handleClose"
    >


      <el-menu-item index="/lotteryRecordBackList">
        <el-icon><List /></el-icon>
        <span>开奖记录</span>
      </el-menu-item>

      <el-menu-item index="/sysUser">
        <el-icon><List /></el-icon>
        <span>修改金额</span>
      </el-menu-item>
<!--      <el-menu-item index="/drawMoneyList">-->
<!--        <el-icon><List /></el-icon>-->
<!--        <span>提现记录</span>-->
<!--      </el-menu-item>-->

<!--      <el-menu-item index="/vipPayList">-->
<!--        <el-icon><List /></el-icon>-->
<!--        <span>充值记录</span>-->
<!--      </el-menu-item>-->
<!--      -->
<!--      <el-menu-item index="/accountLibraryList">-->
<!--        <el-icon><List /></el-icon>-->
<!--        <span>账号库</span>-->
<!--      </el-menu-item>-->
<!--      <el-menu-item index="/qrCodeList">-->
<!--        <el-icon><List /></el-icon>-->
<!--        <span>二维码管理</span>-->
<!--      </el-menu-item>-->

<!--      <el-menu-item index="/globalConfigList">-->
<!--        <el-icon><List /></el-icon>-->
<!--        <span>系统配置管理</span>-->
<!--      </el-menu-item>-->

<!--      <el-sub-menu class="menu_auto_li" :index="item.id" v-for="item in menuList">&lt;!&ndash;disabled&ndash;&gt;-->
<!--        <template #title>-->
<!--          <el-icon><component :is="item.menuIcon"></component></el-icon>-->
<!--          <span>{{item.menuName}}</span>-->
<!--        </template>-->
<!--        <el-menu-item v-if="item.childsMenus.length==0" :index="item.menuUrl">{{item.menuName}}</el-menu-item>-->
<!--        <el-sub-menu v-if="item.childsMenus.length>0" :index="item1.menuUrl" v-for="item1 in item.childsMenus">-->
<!--          <template #title> <span>{{item1.menuName}}</span></template>-->
<!--          <el-menu-item :index="item2.id" v-for="item2 in item1.childsMenus">{{item2.menuName}}</el-menu-item>-->
<!--        </el-sub-menu>-->
<!--      </el-sub-menu>-->
    </el-menu>
  </div>
</template>

<script>
import {
  Document,
  Menu as IconMenu,
  Location,
  Setting,
} from '@element-plus/icons-vue'
export default {
  name: "left",
  data() {
    return {
      isCollapse: true,
      // menuList:[
      //   {
      //     id:"1",
      //     menuName:"开奖记录",
      //     menuIcon:"location",
      //     parentId:0,
      //     menuUrl:"/drawMoneyList",
      //     childsMenus:[]
      //     // childsMenus:[
      //     //   {
      //     //     id:"1-2",
      //     //     menuName:"会员列表",
      //     //     menuIcon:"List",
      //     //     parentId:"1",
      //     //     menuUrl:"",
      //     //     childsMenus:[
      //     //       {
      //     //         id:"1-3",
      //     //         menuName:"会员列表1",
      //     //         menuIcon:"",
      //     //         parentId:"1-2",
      //     //         menuUrl:"/registerList",
      //     //         childsMenus:[
      //     //
      //     //         ]
      //     //       }
      //     //     ]
      //     //   }
      //     // ]
      //   }
      // ]
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$router.push({
        path: key
      })
      console.log("handleSelect  key={},keyPath={}",key,keyPath)
    },
    handleOpen(key, keyPath) {
      this.$router.push({
        path: key,
        // params: {data: 'query' }
      })
      console.log("handleOpen  key={},keyPath={}",key,keyPath)
    },
    handleClose(key, keyPath) {
      console.log("handleClose  key={},keyPath={}",key,keyPath)
    }
  }
}
</script>

<style scoped>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  /*min-height: 400px;*/
  height: 100%;
  overflow-y: scroll;
  position:relative
}
.menu_auto_li{
  border-bottom: 1px solid #cccccc;
}
</style>

